import { client as request } from "./request";

export interface Answer {
  id: number;
  title: string;
  note: string;
  created: Date;
  updated: Date;
  answers: {
    id: number;
    question: string;
    note: string;
    type: string;
    secret: boolean;
    skip: boolean;
    options: {
      id: number;
      text: string;
      selected: boolean;
    }[];
  }[];
}

export interface Question {
  id: number;
  title: string;
  answers: {
    id: number;
    type: string;
    question: string;
    options: {
      id: number;
      text: string;
    }[];
  }[];
}

export const newQuestion = (id: number = 0): Question => ({
  id,
  title: "",
  answers: [
    {
      id,
      type: "",
      question: "",
      options: [
        {
          id,
          text: ""
        }
      ]
    }
  ]
});

export const newAnswer = (id: number = 0): Answer => ({
  id,
  title: "",
  note: "",
  created: new Date(),
  updated: new Date(),
  answers: [
    {
      id,
      question: "",
      note: "",
      type: "",
      secret: false,
      skip: false,
      options: [
        {
          id,
          text: "",
          selected: false
        }
      ]
    }
  ]
});

export async function getQuestions(projectId: any): Promise<Question[]> {
  const res = await request.get("get_questions.php", {
    projectId
  });
  return res.templates;
}

export async function saveQuestion(data: FormData): Promise<number> {
  const res = await request.post("save_question.php", data);
  return res.id;
}

export async function copyQuestion(data: FormData): Promise<number> {
  const res = await request.post("save_question_copy.php", data);
  return res.id;
}

export async function deleteQuestion(questionId: any) {
  const data = new FormData();
  data.append("id", questionId);
  await request.post("delete_question.php", data);
}

export async function getAnswers(projectId: any) {
  const res = await request.get("get_answers.php", {
    projectId
  });
  return res as Answer[];
}

export async function createAnswer(questionId: any, projectId: any) {
  const res = await request.get("create_answer.php", {
    questionId,
    projectId
  });
  return res;
}

export async function updateAnswer(data: FormData): Promise<number> {
  const res = await request.post("update_answer.php", data);
  return res;
}

export async function deleteAnswer(answerId: any) {
  const data = new FormData();
  data.append("id", answerId);
  await request.post("delete_answer.php", data);
}
